import { USER } from "../../pool";
import axiom from "../../utils/axiom";


export const getWhatsappData = (whatsapp_url) => axiom.post(USER.base + USER.paths.getWhatsappUrlData, { url: whatsapp_url });;

